import { useMedia } from "react-use";

export type UseDynamicViewportProps = {
  defaultState?: boolean;
  minimumWidth: number;
};

export const useDynamicViewport = ({
  minimumWidth,
  defaultState = false,
}: UseDynamicViewportProps) =>
  useMedia(`(min-width: ${minimumWidth}px)`, defaultState);
